// Note: This file should use ES5 Javascript compatible with IE11 as some customers use it at
// run-time in the browser directly.

var urlMap = require('./dist');
module.exports = urlMap;
